import React, { useState, useEffect } from 'react';
import { IState, IProps, IComboProps } from './types';
import ComboBox from '@components/ComboBox';
import { IBrandImageType } from '../../../../../../../state/dsconfig/types';
import { IType } from '../../../../../../../state/brandsImages/types';
import { getArrayDepth } from '@utils/brand';
import { flatten } from 'lodash';
import * as S from './styles';

const Combo:React.FC<IComboProps> = (props) => {
  const [selected, setSelected] = useState<string|undefined>(undefined);

  useEffect(() => {
    if (props.metaData) {
      if (props.metaData.findIndex((item: IType) => props.id===item.id)===-1) setSelected("");
      else {
        props.metaData.forEach((item: IType) => {
          if (props.id===item.id) setSelected(item.value);
        });
      }
    }
  }, [props.metaData]);

  const handleSelectOption = async(id: string, value: string) => {
    setSelected(value);
    props.onChange({id: id, value: value, level:props.level});
  }

  const getOption = () => {
    if (selected) return flatten(selectedType?.types?.map((type) => { return (type as IBrandImageType).value }).sort());
    else return [];
  }
  
  const getTittle = () => {
    if (props.level && props.labels && props.labels[props.level]) return props.labels[props.level];
    else return 'Sub-Subtypes'
  }

  const getId = () => {
    if (props.level && props.ids && props.ids[props.level]) return props.ids[props.level];
    else return 'sub-subtype'
  }

  let nextLevel = props.level ? props.level < props.levels : true;
  const selectedType: IBrandImageType|undefined = props.types?.find((type:IBrandImageType) => {
    if (selected) {
      let formatString = selected.replace(/\''/g,`"`);
      formatString = formatString.replace(/\`/g,"'");
      if (type.value===formatString) return type;
    }
  });
  if (selected && (!selectedType?.types || selectedType?.types.length==0)) nextLevel=false;

  return (
    <>
      <ComboBox
        id={props.id??''}
        placeholder={`Select ${props.tittle}`}
        title={props.tittle}
        options={props.options}
        required={false}
        position={"bottom"}
        chooseOption={handleSelectOption}
        value={selected}
        containerStyle={{
          padding: "0px",
          width: "250px",
        }}
        titleStyle={{
          fontFamily: "Roboto",
          fontSize: "16px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "normal",
          letterSpacing: "normal",
          textAlign: "left",
          color: "#000000",
          margin: "0px 0px 7px 0px",
        }}
        disabled={props.options.length>0 ? false:true}
      />
      {nextLevel &&
        <Combo 
        options={getOption()} 
        tittle={getTittle()}
        id={getId()}
        types={selectedType?.types ? selectedType?.types : []}
        level={props.level ? props.level+1 : 2}
        levels={props.levels}
        onChange={(value:any)=> props.onChange(value)}
        metaData={props.metaData}
        labels={props.labels}
        ids={props.ids}/>
      }

    </>
  );
}

const Metadata: React.FC<IProps> = (props) => {
  const [values, setValues] = useState<IState['item'][]>([]);

  useEffect(() => {
    if (values.length>0) {
      let valuesReturn: IType[] = [];
      values.forEach(item => {
        valuesReturn = [...valuesReturn, {id: item.id, value: item.value}];
      });
      props.onChange([...valuesReturn]);
    }
  }, [values]);

  const handleChange = (value: IState['item']) =>{
    if (values.length==0) setValues([value]);
    else {
      let found =false;
      let newValues = values?.filter(item => {
        if (item.level<value.level) return item;
      });
      if(!found) newValues = [...newValues, value];
      setValues(newValues)
    }
  }
  
  useEffect(() => {
    if (props.metaData?.length) {
      let newValues: IState['item'][] = [];
      props.metaData.map((item, index) => {
        newValues = [...newValues, {...item, level: index + 1}];
      })
      setValues(newValues);
    }
  }, []);
  
  const types = props.typeInfo?.types;
  const labels = props.typeInfo?.labels;
  const ids = props.typeInfo?.ids;
  
  return (
    <S.Root>
      <S.Row edit={props.edit} minWidth={props.section==="stocks" ? '520px' : 'unset'}>
        <Combo 
          options={flatten(types?.map(type => { return type.value }).sort())} 
          tittle={labels ? labels[0] : 'Type'}
          id={ids ? ids[0] : 'type'}
          types={types}
          level={1}
          levels={getArrayDepth(types)}
          onChange={(value:any)=> handleChange(value)}
          metaData={props.metaData}
          labels={labels}
          ids={ids}/>
      </S.Row>
    </S.Root>
  );

}

export default Metadata;